module.exports = __webpack_public_path__ + "static/media/FavSvg.1bbde294.svg";